import React from 'react'
import './Tabs.css'

function TabsTwo({ langLocal,tabs, handleSectionClick, activeSection, }) {
    return (
        <div className='tabs-two' >
            {
                tabs.map((tab) => {
                    return (
                        <div className={` ${activeSection === `${tab.type}` ? 'tabs-two-active' : ""}`} onClick={() => {
                            handleSectionClick(tab.type);
                        }}>
                            <i className={`${tab.icon} ${langLocal === 'en'? 'margin_right_10' : 'margin_left_10'}`} ></i>
                            <span>{tab.name}</span>
                        </div>
                    )
                })
            }
        </div>
    )
}

export default TabsTwo